/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_No_PipelineInputs */

const cs_deals_no_pipeline = /** @type {(inputs: Deals_No_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí pipeline není nastavená (spusťte seed na BE).`)
};

const en_deals_no_pipeline = /** @type {(inputs: Deals_No_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default pipeline is missing (run BE seed).`)
};

/**
* | output |
* | --- |
* | "Default pipeline is missing (run BE seed)." |
*
* @param {Deals_No_PipelineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_no_pipeline = /** @type {((inputs?: Deals_No_PipelineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_No_PipelineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_no_pipeline(inputs)
	return cs_deals_no_pipeline(inputs)
});